import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  initialState,
  NewAllyData
} from '@/modules/allies/allies/store/allySlice/initialState.ts'

const allySlice = createSlice({
  name: 'allies',
  initialState,
  reducers: {
    setIsCreateAllyModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isCreateAllyModalOpen = action.payload
    },
    setIsEditAllyModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isEditAllyModalOpen = action.payload
    },
    setSelectedAllyId: (state, action: PayloadAction<string | null>) => {
      state.selectedAllyId = action.payload
    },
    setAllyFilters: (state, action: PayloadAction<string>) => {
      state.allyFilters = action.payload
    },
    setNewAllyData: (state, action: PayloadAction<NewAllyData>) => {
      state.newAllyData = action.payload
    },
    setWalletId: (state, action: PayloadAction<string>) => {
      state.walletId = action.payload
    },
    reset: () => initialState
  }
})

export const allyActions = allySlice.actions
export const { reducer: alliesReducer } = allySlice
